import styles from './styles/Toolbar.module.scss';
import React from 'react';
import { clsx } from '../../../utils/clsx';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
export const ToolbarSkeleton = () => (React.createElement("div", { className: clsx('skeleton bdrs:2 ', !MEDIA_BREAKPOINTS.MD_UP.matches && 'pos:f l:0 b:0 w:100p bxsh:3', styles.container) }));
